import axios from '@/axios'

export default {
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  SET_USER_INFO(state, user) {
    state.user = user
  },
  SET_PARENT_USER_INFO(state, parentUser) {
    state.parentUser = parentUser
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
    state.permissionIds = Object.values(permissions).reduce((per, module) => {
      const ids = Object.values(module)
        .filter(per => {
          return !!per.status
        })
        .map(per => per.permissionId)
      per.push(...ids)
      return per
    }, [])
  },
  SET_STATE: (state, payload) => {
    state[payload.action] = payload.data
  },
  SET_GROWER_AND_PROCESSOR_ROLE_GROUP(state, roleGroup) {
    state.growerAndProcessorRoleGroup = roleGroup
  }
}
